import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeApiCall } from '../../utils/makeApiCall';
import { serializeError } from '../../utils/errorHandling';

export const fetchCreditBalance = createAsyncThunk(
  'creditBalance/fetchCreditBalance',
  async (_, { rejectWithValue }) => {
    try {
      return await makeApiCall({
        url: '/subscriptions/balance',
        method: 'GET',
      });
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);
